<script lang="ts">
	import Introduction from "./Introduction.svelte";

	import GlitchArt from "./GlitchArt.svelte";
	import Steal from "./Steal.svelte";
	import Lava from "./Lava.svelte";
	import Aesemic from "./Aesemic.svelte";

	import About from "./About.svelte";

</script>

<main class="container">

	<section>
		<Introduction />
	</section>

	<section>
		<GlitchArt />
	</section>

	<section>
		<Steal />
	</section>

	<section>
		<Lava />
	</section>

	<section>
		<Aesemic />
	</section>

	<section>
		<h1>About Pandelune</h1>
		<About />
	</section>

	<footer>
		<span id="copyright"
			>&copy; Copyright 2024, Pandelune. All the content is under copyright.</span>
	</footer>
</main>

<style>
</style>
